// Currency-aware formatter that lives outside React (for lightweight callers).
// The active symbol comes from window.__ACTIVE_CURRENCY_SYMBOL__, which is
// synced by AppShell whenever the AuthContext resolves a facility. AuthContext
// already gracefully falls back to `${currencyCode} ` (e.g. "AED ") when the
// facility has no explicit symbol, so we don't need our own ₹ hardcode here.

export const activeSymbol = () => window.__ACTIVE_CURRENCY_SYMBOL__ || "";

// Digit grouping follows the gym's currency (CR-0017): India keeps 1,80,000; every other
// currency (LKR, AED, …) uses 180,000. AuthContext sets window.__NUMBER_LOCALE__.
export const localeFor = (code) => ((code || "INR").toUpperCase() === "INR" ? "en-IN" : "en-US");
export const numberLocale = () => (typeof window !== "undefined" && window.__NUMBER_LOCALE__) || "en-IN";
export const fmtN = (n) => new Intl.NumberFormat(numberLocale()).format(Math.round(Number(n) || 0));
export const fmtMoney = (n) => `${activeSymbol()}${fmtN(n)}`;

/**
 * Convenience helper: given the AuthContext value, format an amount with that
 * facility's currency symbol (no React coupling).
 */
/** Tax contained in an amount collected: 26,250 at 5% → 1,250 (= 26,250 × 5/105).
 *  Catalog prices are ex-GST; staff record the cash collected (price + GST), so tax is
 *  taken out of the amount paid, never added on top of it. */
export const taxIncluded = (amount, rate) =>
  Math.round(((Number(amount) || 0) * (Number(rate) || 0) / (1 + (Number(rate) || 0))) * 100) / 100;

export const fmtMoneyWith = (symbol, n) => `${symbol || activeSymbol()}${fmtN(n)}`;
